import { Navigate } from "react-router-dom";
import { useAppSelector } from "../ReduxToolkit/Hooks";
import React from 'react';

const PrivateRouters = ({ children }: { children: React.ReactNode }): React.ReactElement | null => {
    const { isAuthenticated, user } = useAppSelector((state) => state.auth);
    const requiresPasswordUpdate = isAuthenticated && user?.first_login === true;
    let destinationPath = `${process.env.PUBLIC_URL}/dashboard`;

    if (requiresPasswordUpdate) {
        destinationPath = `${process.env.PUBLIC_URL}/update-password`;
    }
    return isAuthenticated 
        ? <Navigate to={destinationPath} /> 
        : <>{children}</>;
};

export default PrivateRouters;